export const BUTTON_WIDTH = "10rem";
